import { useLayoutEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./clamped_text.module.scss"

// Phone-only line clamp with a "see more" escape hatch; the clamp is pure
// CSS so HTML children (e.g. rendered markdown) are never rewritten.
export default function ClampedText({ children, className = undefined, lines = 3 }) {
  const boxRef = useRef(null)
  const [expanded, setExpanded] = useState(false)
  const [overflows, setOverflows] = useState(false)

  useLayoutEffect(() => {
    const box = boxRef.current
    if (!box || expanded) return

    const measure = () => setOverflows(box.scrollHeight > box.clientHeight + 1)
    measure()

    const observer = new ResizeObserver(measure)
    observer.observe(box)
    return () => observer.disconnect()
  }, [expanded])

  return (
    <div className={className}>
      <div
        ref={boxRef}
        className={classnames({ [styles.clamped]: !expanded })}
        style={{ "--clamped-lines": lines }}
      >
        {children}
      </div>
      {(overflows || expanded) && (
        <button type="button" className={styles["see-more"]} onClick={() => setExpanded(!expanded)}>
          {expanded ? "see less" : "see more"}
        </button>
      )}
    </div>
  )
}

ClampedText.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  lines: PropTypes.number,
}
